@if (categories$ | async; as categories) {
  @if (categories.length) {
    <div class="my-2 px-2">
      <div class="mb-2 flex justify-between">
        <h1 class="text-lg font-semibold">Danh mục sản phẩm</h1>
        <a
          class="btn btn-ghost btn-xs text-sm text-slate-400"
          [routerLink]="['/products', 'categories']">
          Xem thêm
        </a>
      </div>
      <div class="bg-base-200 px-1 py-2">
        <market-carousel-wrapper [options]="options">
          @for (item of categories; track item.id) {
            <li class="splide__slide">
              <a
                class="block cursor-pointer overflow-hidden"
                [routerLink]="['/products']"
                [queryParams]="{ categories: item.id }">
                <div class="mx-auto w-fit">
                  <img
                    class="h-24 w-24 rounded object-cover"
                    [src]="item.image | image"
                    [alt]="item.name"
                    marketImageFailed />
                </div>
                <p class="block w-full text-center text-sm">
                  {{ item.name }}
                </p>
              </a>
            </li>
          }
        </market-carousel-wrapper>
      </div>
    </div>
  }
}
@if (loading()) {
  <market-carousel-categories-skeleton />
}
